module.exports = __webpack_public_path__ + "static/media/59-iveco.d725e6a3.jpg";